import React, { useState , useEffect} from 'react';

import { makeStyles } from '@mui/styles';





//This component interpolates between numbers, and renders the increasing number as a component. 
//It's used when fetching invoices in bulk, -new bulks arrive from the server in batches, and this component displays the
//number of invoices as a steady increasing number. 
const Interpolator = (props) => {
   
    const [currentNo, setCurrentNo] = useState(0);

    const [previousTargetNo, setPreviousTargetNo] = useState(0);
    const [targetNo, setTargetNo] = useState(0);

    const [interpolationTime, setInterpolationTime] = useState(500); // guestimated time between target number is updated
    const [targetNoUpdatedTime, setTargetNoUpdatedTime] = useState(0);

    const [intervalId, setIntervalId] = useState();

    const [redraw, setRedraw] = useState();
    

    useEffect(() =>  { 
        return () => {
            // Cleanup function, on component unmount
            stopInterval();
        }
    },[]) // run on mount


    //creates and runs interval
    const createAndStartInterval = ()=> {
        const intervalId = setInterval(()=>setRedraw(Date.now()), 100); //start the interval

        setIntervalId(intervalId);
    }

    //clears interval, cleanup
    const stopInterval = ()=> {
        if (intervalId) {
            clearInterval(intervalId); //stops the interval
            setIntervalId(null);
            console.log("Interval stopped");
        }
    }
    

    useEffect(() =>  {             

        if (!intervalId)
            createAndStartInterval();

        setTargetNoUpdatedTime(Date.now());


        setPreviousTargetNo(targetNo);
        setTargetNo(props.targetNo);

        if (targetNoUpdatedTime) {
            setInterpolationTime(Date.now()-targetNoUpdatedTime);
        }                              
      
    },[props.targetNo])


    useEffect(() =>  {   
        interpolate();

        if (Date.now()-targetNoUpdatedTime > interpolationTime*2)
            stopInterval();


    }, [redraw]) //run on interval, trigger component redraw



    const interpolate = () => { //runs on every interval
        const deltaTime = Date.now() - targetNoUpdatedTime; //time since last update of target number

//factor between 0 and 1. Faktor 1.2 gives 20% longer interpolation time, in order to minimize "freezes" where the counter stops when waiting for more invoices from the server         
        var factor = deltaTime / (interpolationTime * 1.2); 

        if (factor>1)
            factor =1;

        const newTargetNo = (previousTargetNo + ((targetNo-previousTargetNo) * factor));
        setCurrentNo(Math.round(newTargetNo));
    }    

    return(              
        <div>
            {currentNo}
        </div>     
    )
};

export default Interpolator;